module.exports = __webpack_public_path__ + "img/875e3e8cdeedd519c868a4286a238dd.94ad0666.png";